import React, { CSSProperties as css } from "react";
import C from "../../shared/constants";

const mTileStyle = ({ small, connectTop, connectBottom }): Record<string, css> => {
  let style = {
    backgroundColor: '#fff',
    padding: 8,
    borderRadius: 5,
    color: C.primaryText,
    fontSize: small ? 12 : 'inherit',
    overflowX: 'hidden',
    minHeight: '55px'
  } as css;

  const titleStyle = {
    color: C.blackMain,
    fontSize: 14,
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 500,
    lineHeight: '20px',
    marginBottom: 0,
    letterSpacing: '0.01em',
  } as css;

  const titleRow = {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
  } as css;

  if (connectTop) {
    style.borderTopLeftRadius = 0;
    style.borderTopRightRadius = 0;
    style.borderTop = 'none';
  }

  if (connectBottom) {
    style.borderBottomStyle = 'dotted';
    style.borderBottomLeftRadius = 0;
    style.borderBottomRightRadius = 0;
  }
  return {backgroundStyle: style, titleStyle, titleRow};
}

const mTitleStyle = (small): css => ({
  fontSize: small ? 12 : 'large',
  fontWeight: small ? 'bold' : 'normal',
  justifyContent: 'space-between',
})

interface iTileProps {
  children,
  title?: string,
  style?: css,
  small?: boolean,
  connectTop?: boolean,
  connectBottom?: boolean,
  className?: string,
  leftIcon?: string,
}

const MinimalTile = (props: iTileProps) => {
  const {
    children,
    title,
    style,
    small,
    connectTop,
    connectBottom,
    className,
    leftIcon
  } = props;

  const baseStyle = mTileStyle({ small, connectTop, connectBottom });

  return (
    <div className={`mtile ${className || ''}`} style={{ ...baseStyle.backgroundStyle, ...style }}>
      {leftIcon || title ?
      <section style={baseStyle.titleRow}>
        {leftIcon && <img src={leftIcon} alt="leftIcon" style={{height: 16, width: 16, color: C.blackMain}}/>}
        {title && (
          <div className="tile-header" style={mTitleStyle(small)}>
            <div style={baseStyle.titleStyle}>{title}</div>
          </div>
        )}
      </section>
      : null}
      {children}
    </div>
  );
};

export default MinimalTile;